
  import { Vue, Component, Prop } from "vue-property-decorator";
  import TabNotificationBubble from "@/components/common/TabNotificationBubble.vue";

  @Component({
    components: {
      TabNotificationBubble,
    },
  })
  export default class ExtendedTab extends Vue {
    @Prop({ type: String, required: true }) readonly notification!: string;
    @Prop({ type: Number, required: true }) readonly count!: number;

    get tabNotification(): string {
      return String(this.count);
    }
  }
